import { BaseDto } from "../base/baseDto.model";
import { Decoder } from "../base/decoder.model";

export class TipoSelladoDto  extends BaseDto{
    public valor : number= 0
}
